import images from './images';
import login from './login';

export default {
    images,
    text: {
        login,
    },
};
